import { render, staticRenderFns } from "./TeamSwitcherModal.vue?vue&type=template&id=ebdc2954&"
import script from "./TeamSwitcherModal.vue?vue&type=script&lang=js&"
export * from "./TeamSwitcherModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports